module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href = "/#person/'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</a></td>\r\n<td>'+
((__t=( age ))==null?'':__t)+
'</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/patients/patients-row.html
// module id = 461
// module chunks = 0